import { Box, Tabs, Tab } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import MyCoupon from "components/coupon/my-coupon";
import RegistCoupon from "components/coupon/regist-coupon";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Cookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import UsedCoupon from "components/coupon/used-coupon";

const useStyles = makeStyles((theme) => ({
  couponNodata: {
    "& .nodata": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: 0,
    },
  },
}));

export default function NoticeList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [val, setVal] = useState(0);

  const onReset = () => {
    dispatch(loadAction({ title: "쿠폰" }));
  };

  const handleChangeTab = (event, newValue) => {
    console.log("num", newValue);
    setVal(newValue);
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "쿠폰", menu: true }));
  }, [init]);

  // window.appBackKeyHandle = () => {
  //   history.goBack();
  // };
  +``
  return (
    <main id="main" className={"container nopad " + classes.couponNodata}>
      <Tabs
        value={val}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="My 쿠폰" />
        <Tab label="쿠폰등록" />
        <Tab label="사용내역" />
      </Tabs>
      {/* {storeCode !== null ? ( */}
      <>
        {val == 0 && <MyCoupon />}
        {val == 1 && <RegistCoupon />}
        {val == 2 && <UsedCoupon />}
      </>
      {/* ) : (
        <div className="bg-grey">
          <div className="nodata" style={{ height: "calc(100vh - 111px" }}>
            <Box className="illust">
              <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
            </Box>
            <p className="info-txt">
              단골매장을 설정해야
              <br />
              쿠폰 서비스를 이용하실 수 있습니다.
            </p>
            <Box mt={5}>
              <Link
                to={"/favorite-store"}
                className="link-outlined link-primary link-size-small btn-rounded end-icon"
              >
                단골매장 설정하기
                <i className="ico-go" />
              </Link>
            </Box>
          </div>
        </div>
      )} */}
    </main>
  );
}
